import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';
import 'firebase/analytics';

// Initialize Firebase
firebase.initializeApp(
  {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
  },
);

firebase.analytics();

console.log(process.env.NODE_ENV);
// if (process.env.NODE_ENV == 'development') {
//   firebase.functions().useFunctionsEmulator(process.env.VUE_APP_FIREBASE_EMULATOR_URL);
//   console.log('Use functions emulator in', process.env.NODE_ENV, process.env.VUE_APP_FIREBASE_EMULATOR_URL);
// }

// Enable persistence on browsers that support it.
firebase.firestore().enablePersistence({synchronizeTabs:true})
  .catch(function(err) {
    if (err.code == 'failed-precondition') {
      console.log('Local persistence failed.')
    } else if (err.code == 'unimplemented') {
      console.log('Local persistence failed.')
    }
  });

const firestore = firebase.firestore;
const auth = firebase.auth;
const { currentUser } = auth();
const storage = firebase.storage;
const functions = firebase.functions;
const unsplashSearch = functions().httpsCallable('unsplash-search');
const unsplashDownload = functions().httpsCallable('unsplash-download');
const linkPreview = functions().httpsCallable('linkPreview-create');

export {
  firestore,
  auth,
  storage,
  functions,
  currentUser,
  unsplashSearch,
  unsplashDownload,
  linkPreview,
};
